<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      let _this = this;
      this.chart.setOption({
        grid: {
          left: "5%",
          right: "2%",
          bottom: "10%",
        },
        legend: {
          // data: [
          //   "闲散青少年",
          //   "有或(严重)不良行为青少年",
          //   "流浪乞讨青少年",
          //   "服刑在教人员未成年子女",
          //   "农村留守儿童",
          // ],
          textStyle: {
            color: "#409EFF",
          },
          //   right: "5%",
          top: "0%",
        },
        tooltip: {
          trigger: "axis",
          backgroundColor:'rgba(255,255,255,1)'
        },
        xAxis: {
          type: "category",
          data: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
          ],
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "",
          },
          splitArea: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: _this.isbig ? "#1A48DD" : "#ddd",
            },
          },
        },
        series: [
          {
            name: "晋安区人民检察院",
            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            stack: "one",
            barMaxWidth: 30,
            itemStyle: {
              color: "#6390f9",
            },
          },
          {
            name: "晋安区政法委员会",
            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "晋安区公安分局",
            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "晋安区民政局",

            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "晋安区教育局",

            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "晋安区人力资源和社会保障局",

            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "晋安区妇女联合会",

            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "中国共青团福州市晋安区委",

            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "福州市晋安区工商业联合会",
            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "晋安区司法局",
            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "晋安区人民法院",
            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "北极星王庄街道社工站",
            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "北极星岳峰镇社工站",
            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
          {
            name: "北极星两岸社区交流中心社工站",
            data: [
              120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130,
            ],
            type: "bar",
            barMaxWidth: 30,
            stack: "one",
          },
        ],
      });
    },
  },
};
</script>
